import { useNavigate } from "react-router";
import { useTranslation } from "../localization/useTranslation";
import { useUrlProvider } from "../useUrlProvider";
import { DotLegalBreadCrumbModel } from "@dotlegal/dotlegal-ui-components";

export function useMasterDataMapping() {
    const navigate = useNavigate();
    const urlProvider = useUrlProvider();
    const { translateString } = useTranslation();

    const getBreadCrumbs = () => {
        let breadCrumbs: Array<DotLegalBreadCrumbModel> = [];

        breadCrumbs.push({ name: translateString("masterData") });

        return breadCrumbs;
    };

    function redirectTo(url: string) {
        navigate(url);
    }

    return {
        redirectTo,
        getBreadCrumbs,
    };
}
